import React, { useEffect } from "react"
import SiteHeader from "../components/site-header"
import PageMetadata from "../components/page-metadata"
import { Location } from "@reach/router"
import SiteFooter from "../components/site-footer"
import Helmet from "react-helmet"

const Layout = ({ children }) => {
  // Scroll to anchor on page load or to the top of the page
  useEffect(() => {
    if (typeof window !== "undefined") {
      const hash = window.location.hash
      if (hash) {
        const id = hash.replace("#", "")
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({ behavior: "smooth" })
        }
      } else {
        window.scrollTo(0, 0)
      }
    }
  }, [])

  const handleKeydown = event => {
    if (event.keyCode === 9 || event.keyCode === 13) {
      document.body.classList.add("user-is-tabbing")
    }
  }

  const handleClick = e => {
    if (e.detail === 1) {
      document.body.classList.remove("user-is-tabbing")
    }
  }

  const getPage = pathname => {
    let base = pathname.split("/")
    let lastSegment = base.pop() || base.pop()
    if ((lastSegment === "") | (lastSegment === "eng")) {
      return "home"
    } else {
      return lastSegment
    }
  }

  useEffect(() => {
    window.addEventListener("click", handleClick)
    return () => {
      window.removeEventListener("click", handleClick)
    }
  })

  useEffect(() => {
    window.addEventListener("keydown", handleKeydown)
    return () => {
      window.removeEventListener("keydown", handleKeydown)
    }
  })

  function getThemeColor({ pathname }) {
    if (pathname.includes("in-focus")) {
      return "theme-color-in-focus"
    } else if (pathname.includes("what-we-do")) {
      return "theme-color-what-we-do"
    } else if (pathname.includes("who-we-are")) {
      return "theme-color-who-we-are"
    } else if (
      pathname.includes("downloads") ||
      pathname.includes("english") ||
      pathname.includes("arabic") ||
      pathname.includes("chinese") ||
      pathname.includes("french") ||
      pathname.includes("german") ||
      pathname.includes("japanese") ||
      pathname.includes("portuguese") ||
      pathname.includes("russian") ||
      pathname.includes("spanish")
    ) {
      return "theme-color-downloads"
    } else if (pathname.includes("message-from-the-md")) {
      return "theme-color-message-from-the-md"
    } else {
      return null
    }
  }

  return (
    <Location>
      {({ location }) => (
        <>
          <Helmet>
            <body className={getThemeColor(location)} />
          </Helmet>
          <PageMetadata template={getPage(location.pathname)} />
          <a className="skip-main" href="#main">
            Skip to main content
          </a>
          <SiteHeader path={location.pathname} hash={location.hash} />
          <span className="anchor" id="main" tabIndex="-1" />
          <main>{children}</main>
          <SiteFooter path={location.pathname} />
        </>
      )}
    </Location>
  )
}

export default Layout
